module.exports = __webpack_public_path__ + "static/media/accepted_inactive.45233538.svg";